<template>
  <Modal id="detailedReport" name="detailedReport" v-bind="$attrs" :key='id' size="w-screen h-screen">
    <template v-slot:header>
        <div>
            {{ $t('historical_data') }} <span class="font-bold">{{ $attrs.dinamicId }}</span>
        </div>
        <div v-show="!loading" class="flex pr-4 space-x-4">
            <feather v-show="!!total" @click="showMap = !showMap" size="24px" type="map" class="cursor-pointer" :class="{'text-cyan' : showMap}" v-tooltip="'Map'" />
            <div class="filter-switch relative" @click="showFilters = !showFilters">
                <div v-show="payload.activeFilters.length" class="badge -right-2 -top-2 absolute bg-cyan flex h-4 items-center justify-center p-0 rounded-full w-4">{{ payload.activeFilters.length }}</div>
                <feather  size="24px" type="filter" class="cursor-pointer" :class="{'text-cyan' : showFilters}" v-tooltip="$t('filters')" />
            </div>
            <feather v-show="!!total" @click="csvExport" size="24px" type="download" class="cursor-pointer" v-tooltip="$t('csv_export')" />
        </div>
    </template>
    <template v-slot:body>
        <loader v-if="loading" :show="!!loading"></loader>
        <div v-else class="col-start-1">
            <TabFilters
                class="mb-2"
                v-show="showFilters" 
                :filtersList="payload.activeFilters" 
                :filterOptions="filterOptions"
                :date_from="payload.date_from"
                :date_to="payload.date_to"
                :backward_interval="payload.backward_interval"
                :cover_type="payload.cover_type"
                @update="updateFilters($event)" 
            >
                <div @click="getData()" class="bg-navy py-1 px-4 rounded-2xl text-white uppercase font-bold text-sm cursor-pointer">{{ $t('re_run') }}</div>
            </TabFilters>
            <div v-if="!total" class="flex flex-col items-center no-content">
                <h2 class="font-bold text-2xl">{{ $t('no_data') }}</h2>
                <p class="mb-4">{{ $t('change_filter_for_more_results') }}</p><svg width="300" height="564"
                    viewBox="0 0 645.35409 564" class="h-40">
                    <path
                        d="M887.88367,677.07144l.99774-22.43416a72.45559,72.45559,0,0,1,33.79563-8.555c-16.23146,13.27042-14.203,38.85123-25.20757,56.69681A43.58213,43.58213,0,0,1,865.51026,722.919l-13.58307,8.31648A73.02986,73.02986,0,0,1,867.32,672.05666a70.54258,70.54258,0,0,1,12.9644-12.04606C883.53761,668.58856,887.88367,677.07144,887.88367,677.07144Z"
                        transform="translate(-277.32296 -168)" fill="#f2f2f2"></path>
                    <circle cx="529.90337" cy="507.43962" r="54.43442" fill="#6c63ff"></circle>
                    <path
                        d="M785.01073,654.14789a51.14478,51.14478,0,0,1-3.64907,11.64664c-9.60232,20.31353,17.74322,13.69236,27.51561,13.69236,10.68466,0,20.90767,5.61848,19.34627-19.3463-.66694-10.66383-8.66164-19.34629-19.34627-19.34629C799.75082,640.79431,786.9191,644.85084,785.01073,654.14789Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <circle cx="529.95346" cy="495.76106" r="15.72105" fill="#ffb6b6"></circle>
                    <path
                        d="M796.6002,647.73562a18.00795,18.00795,0,0,1,27.37849,15.71619c-8.01071,2.01125-16.42646,3.55039-24.96923.48107l-2.01749-4.93754-1.18941,4.94119c-2.60156,1.06337-5.2099,1.96308-7.8182-.01026A18.38712,18.38712,0,0,1,796.6002,647.73562Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M849.55166,711.63514a54.41536,54.41536,0,0,1-76.1573,5.50392l4.66895-13.028a14.01008,14.01008,0,0,1,11.90032-8.17186l2.97029-.18235,7.08262-6.10851s19.08373-.68141,18.8006-1.00771l11.55965,6.95306-.00961-.048,4.54419.27833a14.004,14.004,0,0,1,11.90035,8.17186Z"
                        transform="translate(-277.32296 -168)" fill="#3f3d56"></path>
                    <path
                        d="M386.19171,291.749a54.43442,54.43442,0,1,1-54.33782-54.53085A54.29369,54.29369,0,0,1,386.19171,291.749Z"
                        transform="translate(-277.32296 -168)" fill="#f2f2f2"></path>
                    <path
                        d="M306.52752,273.945c2.25084-7.17335,7.36933-13.75249,14.44808-16.17747,7.07917-2.425,17.44485,1.26906,22.76679,6.573,9.73487,9.702,12.11055,43.03175,5.42229,53.56434-1.33032-.07042-5.92073-.1225-7.26717-.17293l-1.90469-6.34826v6.28569q-3.21759-.09944-6.48554-.1373a28.2255,28.2255,0,0,1-27.867-27.52907C305.46605,283.01665,305.64051,276.7718,306.52752,273.945Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <circle cx="53.62708" cy="114.20571" r="15.51343" fill="#ccc"></circle>
                    <path
                        d="M317.56147,268.58116l17.86222-8.94406,0,0a22.451,22.451,0,0,1,13.14953,18.601l.44522,5.333-7.47983-1.904-.81947-6.81926-1.2702,6.28734-3.45187-.87829L336.0299,269.67l-3.454,10.57932-12.32865-2.83249Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <path
                        d="M372.15132,327.67491a54.41538,54.41538,0,0,1-76.1573,5.50391l4.66895-13.028A14.01011,14.01011,0,0,1,312.5633,311.979l2.97028-.18234,7.08262-6.10851s19.08373-.68141,18.8006-1.00771l11.55965,6.953-.0096-.048,4.54418.27832a14.004,14.004,0,0,1,11.90036,8.17187Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <circle cx="54.82194" cy="373.65244" r="54.43442" fill="#f2f2f2"></circle>
                    <path
                        d="M309.9293,520.3607a51.14478,51.14478,0,0,1-3.64907,11.64664c-9.60231,20.31353,17.74323,13.69236,27.51561,13.69236,10.68466,0,20.90767,5.61848,19.34628-19.34629-.66695-10.66384-8.66165-19.3463-19.34628-19.3463C324.66939,507.00712,311.83767,511.06366,309.9293,520.3607Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <circle cx="54.87203" cy="361.97387" r="15.72105" fill="#ccc"></circle>
                    <path
                        d="M321.51877,513.94843a18.008,18.008,0,0,1,27.37849,15.7162c-8.01071,2.01125-16.42646,3.55038-24.96923.48106l-2.01749-4.93754-1.1894,4.9412c-2.60157,1.06336-5.20991,1.96307-7.81821-.01027A18.38713,18.38713,0,0,1,321.51877,513.94843Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <path
                        d="M374.47023,577.848a54.41536,54.41536,0,0,1-76.1573,5.50392l4.66895-13.028a14.01011,14.01011,0,0,1,11.90033-8.17186l2.97028-.18235,7.08262-6.1085s19.08373-.68142,18.8006-1.00771l11.55965,6.95305-.0096-.048,4.54418.27832a14.004,14.004,0,0,1,11.90036,8.17186Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <circle cx="289.01361" cy="290.203" r="88.13386" fill="#f2f2f2"></circle>
                    <circle cx="292.60572" cy="270.45435" r="28.73888" fill="#ccc"></circle>
                    <path id="e457262b-f043-4272-b9dd-aba1e09de7d8-157" data-name="bf427902-b9bf-4946-b5d7-5c1c7e04535e"
                        d="M595.23229,419.46891s7.4826-14.30447-8.97935-15.6049c0,0-14.034-12.73059-28.33842-2.32734,0,0-7.80244,0-12.0691,8.82937,0,0-6.13659-2.32734-7.48515,3.90122,0,0-4.49033,13.0041,0,24.70778s5.98183,13.00406,5.98183,13.00406-3.15052-14.5236,14.80949-15.824,34.43663-12.5516,35.93339,1.75285,3.14213,7.84258,3.14213,7.84258S612.4431,425.32077,595.23229,419.46891Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <path
                        d="M632.13005,516.80656a88.103,88.103,0,0,1-123.305,8.9113l7.55942-21.09341a22.68351,22.68351,0,0,1,19.26762-13.23093l4.80914-.29524,11.46736-9.89018s30.89814-1.10326,30.43973-1.63156l18.716,11.25757-.01556-.07767,7.35742.45062A22.67359,22.67359,0,0,1,627.69386,504.438Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <circle cx="143.85613" cy="236.05929" r="54.43442" fill="#f2f2f2"></circle>
                    <circle cx="142.35373" cy="225.42648" r="17.37605" fill="#ccc"></circle>
                    <path
                        d="M462.01689,440.48a54.41538,54.41538,0,0,1-76.15731,5.50392l4.66895-13.028a14.01011,14.01011,0,0,1,11.90033-8.17186l2.97029-.18235,7.08262-6.1085s19.08372-.68142,18.8006-1.00771l11.55965,6.953-.00961-.048,4.54419.27832A14.004,14.004,0,0,1,459.277,432.8408Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <path
                        d="M438.00265,382.6502a22.40267,22.40267,0,0,0-9.38192-12.76467c-3.648-2.3333-8.20016-3.52449-12.333-2.29057s-7.55451,5.2898-7.284,9.672a4.2398,4.2398,0,0,0-4.27974,1.32164,9.81145,9.81145,0,0,0-2.09974,4.25128,27.02774,27.02774,0,0,0,.25349,14.9665l-.08207.69834c2.0163-.33356,3.54568-2.06356,4.49671-3.90676s1.49831-3.88808,2.52907-5.68621,2.74242-3.40211,4.78434-3.45822l-.17994,3.12123,5.27029-2.71533q-.62682,1.49938-1.25361,2.99878,2.30131-.96189,4.60264-1.92374-.25727,1.4418-.5145,2.88356a6.848,6.848,0,0,1,9.428-3.04833,9.1,9.1,0,0,1,3.72021,5.23332,27.56917,27.56917,0,0,1,.89087,6.53149A22.84088,22.84088,0,0,0,438.00265,382.6502Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                    <path d="M536.69739,447.90214v.03241a1.40326,1.40326,0,0,1-.09714-.37245Z"
                        transform="translate(-277.32296 -168)" fill="#f2f2f2"></path>
                    <path
                        d="M536.69739,447.93455c.08094.33995.17808.68.27522,1.00383a2.99353,2.99353,0,0,1-.40477.08093Z"
                        transform="translate(-277.32296 -168)" fill="#f2f2f2"></path>
                    <path
                        d="M654.46949,458.02141a88.12563,88.12563,0,0,1-84.678,88.04575V369.97565A88.10743,88.10743,0,0,1,654.46949,458.02141Z"
                        transform="translate(-277.32296 -168)" fill="#6c63ff"></path>
                    <path d="M536.60025,447.5621l.09714.34v.03241A1.40326,1.40326,0,0,1,536.60025,447.5621Z"
                        transform="translate(-277.32296 -168)" fill="#ffb6b6"></path>
                    <path
                        d="M592.03765,440.81055a27.66543,27.66543,0,0,1-.85806,6.89731v.0162a28.17179,28.17179,0,0,1-21.38813,20.59469V413.28613A28.16473,28.16473,0,0,1,592.03765,440.81055Z"
                        transform="translate(-277.32296 -168)" fill="#a0616a"></path>
                    <path
                        d="M632.45,516.98839a87.79734,87.79734,0,0,1-62.65854,29.8559V480.67237c6.8811-.32384,13.11454-.66378,12.904-.90668l18.71669,11.25264-.0162-.08093,7.3506.45329a22.64076,22.64076,0,0,1,19.26713,13.228l4.2582,11.86781Z"
                        transform="translate(-277.32296 -168)" fill="#3f3d56"></path>
                    <path
                        d="M536.69739,447.93455c.08094.33995.17808.68.27522,1.00383a2.99353,2.99353,0,0,1-.40477.08093Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M591.26052,449.06793c-.03241-.45339-.04862-.89057-.08093-1.34387v-.0162a40.08145,40.08145,0,0,0-1.36008-9.21259c-1.05244-3.4-3.02768-6.65441-6.02294-8.46778-4.48489-2.72-10.78315-1.24672-14.00511,2.8334V398.90866a29.57745,29.57745,0,0,1,8.59733,3.7887,36.24188,36.24188,0,0,1,15.187,20.65952A37.01323,37.01323,0,0,1,591.26052,449.06793Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M568.58,732a1.05882,1.05882,0,0,1-1.1096-1V169a1.11561,1.11561,0,0,1,2.2192,0V731A1.05882,1.05882,0,0,1,568.58,732Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M679.144,430.69623l-30.65811-7.52054-40.87509-34.75023,6.80663-10.80566,37.028,23.58855s24.49751,6.21979,32.8764,13.3917Z"
                        transform="translate(-277.32296 -168)" fill="#ffb6b6"></path>
                    <circle cx="331.71053" cy="213.6137" r="7.46893" fill="#ffb6b6"></circle>
                    <path
                        d="M680.58368,410.58659l-28.43081-11.59291L638.4886,415.21983l10.15131,8.36367,27.67322,7.19191.01961.07258c1.9434,7.16357,14.44118,12.02722,24.58324,14.8456a13.69555,13.69555,0,0,0,16.57515-8.65285h0a13.72574,13.72574,0,0,0-3.225-14.126l-9.21-9.23511Z"
                        transform="translate(-277.32296 -168)" fill="#e6e6e6"></path>
                    <polygon points="324.649 533.953 314.685 530.161 324.567 489.926 339.272 495.522 324.649 533.953"
                        fill="#ffb6b6"></polygon>
                    <path
                        d="M605.75151,699.66681,602.947,698.5997l-9.25529-8.61861-7.5624,2.21944-.0008-.0003a13.38013,13.38013,0,0,0-17.26251,7.7472l-.1546.40637,32.12719,12.22437Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <polygon points="425.371 550.657 414.711 550.656 409.639 509.537 425.373 509.538 425.371 550.657"
                        fill="#ffb6b6"></polygon>
                    <path
                        d="M705.414,715.17643l-3.00065-.00011-11.71507-4.76423-6.27893,4.76351h-.00085a13.38011,13.38011,0,0,0-13.37943,13.37924v.43478l34.37429.00129Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M718.95,541.54021s1.24482,14.93785-1.86723,29.25328c-1.9508,8.97366-2.67874,28.16448-2.95036,41.237-.1617,7.78172-3.6617,9.022-3.6617,9.022l2.32161,17.89549-5.66812,65.04138-20.53954-1.86723-5.6017-131.3286-36.91713,29.19114,1.0242,3.414c.49787,1.65957-3.17529,1.44716-4.64416,2.36611h0l-3.62185,8.40305A6.80425,6.80425,0,0,1,632.709,620.769h0L613.47042,678l-15-9,5-52,7-24L638.659,558.34531l.62241-9.95857,2.80085.11514,1.42616-4.16081,2.61951-7.15772Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M720.02582,544.67779l.11092-.15561c5.92445-8.29434-2.98593-28.22546-4.32982-31.11474v0a7.25369,7.25369,0,0,0,4.96507-7.747l-.57933-4.92458-.60387-4.83036,4.32618-4.32618.01216-.10789,2.48964-21.78436,3.61987-14.469a31.76575,31.76575,0,0,0-9.01614-30.7847l-8.36729-7.88923-10.16887-15.04631H686.08589l-5.62266,10.62049a23.90127,23.90127,0,0,0-18.493,24.40284l1.2743,27.85439-4.9887,34.68114-.003,6.27638-2.59832,2.88766a8.98577,8.98577,0,0,0-2.13154,7.7728l.3417,1.70843h0a8.9858,8.9858,0,0,0-5.24677,6.37637l-.9126,4.2584c-.78075,1.03026-5.93417,7.90169-5.93417,9.78017,0,.282.20818.55464.65493.85707,3.512,2.3781,22.92342,7.2264,31.51469,3.78856,9.15138-3.6591,45.52957,1.83015,45.89608,1.88607Z"
                        transform="translate(-277.32296 -168)" fill="#e6e6e6"></path>
                    <circle cx="414.84384" cy="206.92306" r="21.71769" fill="#ffb6b6"></circle>
                    <path
                        d="M685.084,470.32467,669.99722,498.0531l-44.02135,30.66712-8.71374-9.33615,32.24776-29.79224s12.25871-22.10288,21.32949-28.37691Z"
                        transform="translate(-277.32296 -168)" fill="#ffb6b6"></path>
                    <circle cx="342.4288" cy="357.60816" r="7.46893" fill="#ffb6b6"></circle>
                    <path
                        d="M683.726,474.02105l9.4872-22.76965-3.43146-12.58315a13.72723,13.72723,0,0,0-10.65179-9.823h0a13.69484,13.69484,0,0,0-15.75021,10.07683c-2.59844,10.20109-4.59392,23.46256.65432,28.71081l.05319.05318-15.61685,20.36642,23,13Z"
                        transform="translate(-277.32296 -168)" fill="#e6e6e6"></path>
                    <path
                        d="M713.62368,359.95707c-1.7658-2.38-4.30383-4.07208-6.24517-6.31122a43.0169,43.0169,0,0,0-3.14716-3.72045,12.92648,12.92648,0,0,0-8.35559-2.985,21.08461,21.08461,0,0,0-17.21228,8.16852q-2.3672-1.38793-4.73438-2.77582-.9352,2.46149-1.87042,4.923a2.86957,2.86957,0,0,0-4.37329,3.5907c-.37555-1.16052-2.09631-1.40674-3.045-.64007a3.668,3.668,0,0,0-1.048,3.3407,6.72468,6.72468,0,0,0,5.07264,5.56231c2.05938.4588,4.45629-.02319,6.10455,1.29389,1.32147,1.0559,1.7204,2.97863,3.069,3.99963,1.6618,1.25812,4.01056.67627,6.07623.95429a7.30085,7.30085,0,0,1,6.04132,7.80346,9.04732,9.04732,0,0,1,1.41272-3.246,3.08075,3.08075,0,0,1,3.13037-1.21448c1.88147.564,2.18927,3.12854,1.73328,5.039-1.20935,5.0669-5.79266,13.257-5.79266,13.257,5.95123,2.34754,13.04138.12775,17.63317-4.32684,4.59174-4.45459,6.98322-10.76227,8.025-17.07434C716.98135,370.24266,716.85617,364.314,713.62368,359.95707Z"
                        transform="translate(-277.32296 -168)" fill="#2f2e41"></path>
                    <path
                        d="M910.2149,729.81a1.18647,1.18647,0,0,1-1.19007,1.19h-280.29a1.19,1.19,0,1,1,0-2.38h280.29A1.1865,1.1865,0,0,1,910.2149,729.81Z"
                        transform="translate(-277.32296 -168)" fill="#ccc"></path>
                </svg>
            </div>
            <template v-else>
                <Map v-if="showMap" :items-payload="map"></Map>
                <pagination :loading="loading" :total="total" :per_page="per_page" @page-changed="current_page = $event" class="bg-white py-1 sticky top-0"/>
                <div class="table-wrapper overflow-x-auto">
                    <table class="w-full" >
                        <thead>
                            <tr class="bg-pureNavy2 text-sm text-white">
                                    <th v-for="(column, index) in columns" :key="'col-'+ index" class="p-2 last:pr-0" :class="Array.isArray(rows) ? null: 'w-56 break-all'">{{ $t(column) }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <table-row
                                v-for="(row, index) in rows"
                                :key="'row-'+index"
                                :isArray="Array.isArray(rows)"
                                :columns="columns"
                                :item="row"
                                :dinamicColumn="{ index: -1, name: '' }"
                            />
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
    </template>
    <template v-slot:footer>

    </template>
</Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loader from './Loader.vue'
import Modal from '../modules/modals/components/Modal'
import TableRow from '../components/TableRow.vue'
import TabFilters from './select-report-tabs/TabFilters.vue'
import Pagination from './Pagination'
import Map from '../modules/map/components/Map'

export default {
    name: 'modalDetailedReport',
    components: {
        Loader,
        Modal,
        TableRow,
        Pagination,
        TabFilters,
        Map,
    },
    data(){
        return {
            id: null,
            loading: true,
            data: null,
            columns: [],
            map: [],
            total: 0,
            current_page: 1,
            per_page: 50,
            payload: {
                backward_interval: null,
                cover_type: null,
                date_from: null,
                date_to: null,
                activeFilters: [],
            },
            showFilters: false,
            showMap: true,
        }
    },
    computed: {
        ...mapGetters([
            'isLoading',
            'newReport',
            'allColumns',
        ]),
        rows(){
                const start = this.current_page === 1 ? 0 : (this.current_page - 1) * this.per_page
                const end = start + this.per_page

                if(Array.isArray(this.data)){
                    return this.data.slice(start, end)
                }
                return null
        },
        // filtersList() {
        //         return this.newReport.filters ? this.newReport.filters : []
        // },
        filterOptions (){
            return this.allColumns.filter(column => {
                return this.newReport.service_name == column.service
            }).map(column => {
              return {name: column.name, type: column.type, label: this.$t(column.name, 1)}
            })
        },
    },
    methods: {
        ...mapMutations({
        }),
        ...mapActions({
            getHistoricalData: 'getHistoricalData',
            exportToCsv: 'exportToCsv',
        }),
        getData(){
            this.loading = true
            this.getHistoricalData({dinamicId: this.$attrs.dinamicId, payload: this.payload}).then(response => {
                this.data = response.data.data
                this.columns = response.data.columns
                this.total = response.data.total
                this.loading = false
                this.map = response.data.map
            })
        },
        csvExport(){
            const payload = {
                backward_interval: this.newReport.backward_interval,
                columns: this.newReport.view_columns_stringify,
                filters: this.newReport.filters_stringify,
                group_by: this.newReport.group_by_stringify,
                order_by: this.newReport.order_by_stringify,
                aggregate: this.newReport.aggregate ? this.newReport.aggregate_stringify : null,
                additionalGroupBy: this.newReport.additionalGroupBy ? this.newReport.additionalGroupBy_stringify : null,
                date_from: this.newReport.date_from,
                date_to: this.newReport.date_to,
                cover_type: this.newReport.cover_type,
                chart_id: this.newReport.chart_id,
                service: this.newReport.service_name,
            }
            this.exportToCsv({payload, endpoint: 'history', index_id: this.$attrs.dinamicId})
        },
        updateFilters(event) {
                const key = Object.keys(event)[0];
                const value = Object.values(event)[0];
                switch(key){
                    case 'filters':
                        this.payload.activeFilters = value
                        break;
                    case 'date_from':
                        this.payload.date_from = value
                        break;
                    case 'date_to':
                        this.payload.date_to = value
                        break;
                    case 'backward_interval':
                        this.payload.backward_interval = value
                        break;

                }
                // this.setNewReportItem(event)
                this.$forceUpdate();
        },
        initialFilter(){
            const serviceName = this.newReport.service_name
            switch(serviceName) {
                case 'Lasso':
                    this.payload.activeFilters = [{
                        name:"actionTime",
                        label:this.$t("actionTime"),
                        type:"date",
                        service:"Lasso",
                        value:"true",
                        like: true
                    }]
                    this.payload.backward_interval = 30
                    break;
                case 'LassoV2':
                    this.payload.activeFilters = [{
                        name:"createdAt",
                        label:this.$t("createdAt"),
                        type:"date",
                        service:"LassoV2",
                        value:"true",
                        like:true
                    }]
                    this.payload.backward_interval = 30
                    break;
            }
        }
    },
    mounted() {
        this.initialFilter()
        this.getData()
    }
}
</script>

<style lang="sass" scoped>
h1
    font-size: 25px!important
label
    font-weight: 700
    font-size: 17px
input, select, textarea
    border: 1px solid #F0F1F3!important
    border-radius: 7px
    width: 100%
input[type='checkbox']
    min-width: 25px
    width: inherit
    height: 25px
.label-wrapper
    display: flex
    align-items: center
    margin-bottom: 4px
    label
        margin-left: 10px
.row
    .col
        flex: 1
    &:not(:last-child)
        margin-bottom: 1.5rem
    .form
        padding-left: 30px
.badge
    font-size: 10px
table
    position: relative
    th
      position: sticky
      top: 0
      background-color: rgba(61, 64, 95, var(--tw-bg-opacity))
</style>
